import landing from "./landing";
import auth from "./auth.ts";
import registration from "./registration.ts";
import balance from "./balance.ts";
import organization from "./organization";
import shop from "./shop";
import tariff from "./tariff";
import employee from "./employee";
import documents from "./documents";
import history from "./history";
import clients from "./clients";
import wallet from "./wallet";
import files from "./files";
import catalog from "./catalog";
import promotions from "./promotions";
import reviews from "./reviews";
import spread from "./spread";
import managers from "./managers";
import permissions from "./permissions";
import faq from "./faq";
import app from "./app";
import profile from "./profile";
import pushs from "./pushs";
import cashback from "./cashback";

export default {
  auth,
  registration,
  balance,
  organization,
  shop,
  landing,
  tariff,
  employee,
  documents,
  history,
  clients,
  wallet,
  catalog,
  promotions,
  reviews,
  spread,
  managers,
  files,
  permissions,
  faq,
  app,
  profile,
  pushs,
  cashback,

  //SYSTEM
  sys: {
    error: "Xato: ",
    descError: "Tavsif: ",
    wrongLogin: "Noto'g'ri login",
    wrongPass: "Noto'g'ri parol",
    unknown: "Noma'lum",
    unauthenticated: "Avtorizatsiyadan o'tmagan",
    iikAlready: "Ushbu IIK bilan yuridik shaxs allaqachon mavjud",
    noMoney: "Balansda mablag' yetarli emas",
    wrongPeriod: "ProPlus faqat bir yilga",
    noPermissions: "Foydalanuvchi kerakli ruxsatlarga ega emas.",
    firstLoginManager: "Birinchi marta kirish, parol yarating",
    limitShops: "Savdo nuqtasi yaratish tarif bilan cheklangan",
    limitLegalEntity: "Yuridik shaxs yaratish tarif bilan cheklangan",
    wrongTariff: "Bu sizning tarifingizda mavjud emas",
    wrongTariffPromo: "Promokod ro'yxatdan o'tish uchun mos kelmaydi",
    tagExist: "Ushbu teg allaqachon mavjud",
    503: "Server mavjud emas",
    blockManager: "Menejer bloklangan",
    wrongCode: "Noto'g'ri kod",
    codeExists: "Hamkor promokodi noto'g'ri kiritilgan",
    noExam: "Imtihon topshirilmagan",
    noActivateAccount: "Hisob faollashtirilmagan",
    emailExist:
      "Ushbu pochta egasi allaqachon RC GROUP xizmatlarida ro'yxatdan o'tgan",
    userExist:
      "Ushbu pochta egasi allaqachon RC GROUP xizmatlarida ro'yxatdan o'tgan",
    noAccepted: "Yangi shartnoma qabul qilinmagan",
    balanceNotEnough: "Balansda mablag' yetarli emas",
    innExist: "Ushbu INN bilan yuridik shaxs allaqachon mavjud",
    noTodayChangeTariff:
      "Tarifni faqat joriy tarif tugashidan bir kun oldin o'zgartirish mumkin",
    badToken: "Ushbu havola yaroqsiz",
    wrongEmail: "Noto'g'ri pochta",
    emailTaken: "Elektron pochta manzili band",
    notAvailableCurrentTariff: "Joriy tarif uchun mavjud emas",
    dataNoCorrect: "Ma'lumotlar noto'g'ri",
    accountNotFound: "Hisob topilmadi",
    TPExist: "Savdo nuqtasi allaqachon mavjud",
    serverError: "Server xatosi",
    ownerExist: "Hisob topilmadi",
    unauthorizedAction: "Sizda yetarli huquqlar yo'q",
    legalEntityExist: "Yuridik shaxs topilmadi",
    tariffChangeOneDay:
      "Tarifni joriy tarif tugashidan bir kun oldin o'zgartirish mumkin",
    blockedByTariff: "Tarif bilan bloklangan",
    documentInProcessOfCreation: "Hujjat yaratish jarayonida",
    emailAlreadyVerified: "Sizning pochtangiz allaqachon tasdiqlangan!",
    emailConfirmed: "Sizning pochtangiz muvaffaqiyatli tasdiqlandi!",
    codeDoesNotExist: "Kiritilgan kod yaroqsiz",
    defaultCashbackCanNotBeDeleted:
      "Brendlashtirilgan karta bo'lmagan mijozlar uchun mukofot o'chirilishi mumkin emas",
    cashbackUpdateSuccessful: "Mukofot foizi muvaffaqiyatli yangilandi",
    cashbackDeleteSuccessful: "Mukofot o'chirildi",
    cashbackCreateSuccessful: "Mukofot yaratildi",
    fullCashback: "Brendlashtirilgan karta bo'lmagan mijoz",
    clientGroupAlreadyInUse:
      "Mijozlar guruhi allaqachon cashback guruhida ishlatilmoqda",
    enteredAmountIsAlreadyInUse:
      "Kiritilgan mukofot miqdori allaqachon belgilangan",
    dateStartIsInvalid: "Boshlanish sanasi noto'g'ri kiritilgan",
    dateEndIsInvalid: "Tugash sanasi noto'g'ri kiritilgan",
    organizationNotConfirmed: "Yur.shaxs tasdiqlanmagan",
    periodNotAvailable: "Tanlangan davr sotib olish uchun mavjud emas",
    notAvailableInYourCountry: "Tanlangan davr sotib olish uchun mavjud emas",
    exceededActivatedPromotionLimit:
      "Bir savdo nuqtasida faqat 3 ta faollashtirilgan aksiya",
    tradingPointLimitOnProPlus:
      "ProPlus tarifida 30 tadan ortiq savdo nuqtasi yaratish mumkin emas",
    tradingPointLimitOnPromo:
      "ProPlus tarifida 15 tadan ortiq savdo nuqtasi yaratish mumkin emas",
    tradingPointLimitOnLight:
      "ProPlus tarifida 5 tadan ortiq savdo nuqtasi yaratish mumkin emas",
    wrongDateOrder: "Boshlanish sanasi tugash sanasidan oldin bo'lishi kerak",
    descriptionFormatInvalid:
      "Tavsif xeshteglar va emoji'larni o'z ichiga olmasligi kerak",
    descriptionMustNotContainEmoji:
      "Tavsif emoji'larni o'z ichiga olmasligi kerak",
    descriptionMinLength:
      "Tavsif bo'shliqlarsiz 600 belgidan uzun bo'lishi kerak",
    descriptionMaxLength: "Tavsif 3000 belgidan uzun bo'lmasligi kerak",
    maxFileSizeError: "Fayl hajmi 10 MB chegarasidan oshadi",
    addFile:
      "Torting yoki <span style='color: #447ECB; cursor: pointer'>fayllarni yuklang</span>",
    balance: "Balans",
    changeMainOrganizationError:
      "Asosiy tashkilotni faqat oldingi o'zgartirishdan keyin 30 kun o'tgach o'zgartirish mumkin",
    resetWallet: "Wallet pass dizayni tiklanmadi",
    updateWallet: "Wallet pass dizayni yangilanmadi",
    userUnauthorized: "Login yoki parol noto'g'ri kiritilgan",
    noData: "Ma'lumot yo'q",
    kb: "KB",
    pageUnavailableYet: "Sahifa hozircha mavjud emas",
    dateMask: "kk.oo.yyyy",
    sort: "Saralash",
    noDataTitle: "Hozircha ma'lumot yo'q",
    syncError: "Sinxronizatsiya muammosi. Keyinroq qayta urinib ko'ring.",

    enterName: "Nomni kiriting",
    countries: {
      ru: "Rossiya",
      kz: "Qozog‘iston",
      md: "Moldova",
      ky: "Qirg‘iziston",
      uz: "O‘zbekiston",
    },
    select_country: "Mamlakatni tanlang",
    country: "Mamlakat",
    q_date: {
      days: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba",
      daysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan",
      months:
        "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr",
      monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek",
    },
    errorTitle: "Nimadir noto'g'ri ketdi",
    dateFrom: "Ma'lumotlar dan mavjud ",
    dateToToday: " bugungi kungacha",
    dateFormat: "Format kk.oo.yyyy yoki kk.oo.yyyy - kk.oo.yyyy",
    showBy: "Ko'rsatish: ",
    showByMobile: ": ",
    searchResponseEmpty: "So'rovingiz bo'yicha hech narsa topilmadi",
    search: "Qidirish",
    imageSize: "Mb",
    tagSearchResponseEmpty:
      "Teg topilmadi. Qo'shish uchun Enter yoki Bo'shliq tugmasini bosing.",
    from: "Dan:",
    to: "Gacha:",
    gender: {
      m: "Erkak",
      f: "Ayol",
    },
    500: "Nimadir noto'g'ri ketdi. Internet aloqasini tekshiring.",
    soon: "Tez orada!",
    fromToPercent: "{from} dan {to} % gacha",
    fromToDays: "{from} dan {to} kun gacha",
    timeFormat: "ss:mm – ss:mm",
    language: "Til",
    copied: "Nusxa olindi",
    moderationMessage: "Moderator xabari",
    languageSelecting: "Tilni tanlash",
    showMap: "Xaritani ko‘rsatish",
    hideMap: "Xaritani yashirish",
  },

  message: {
    changesSavedAndSendedToModeration:
      "O'zgarishlar saqlandi va moderatsiyaga yuborildi",
    changesSuccessSaved: "O‘zgarishlar muvaffaqiyatli saqlandi",
    changesSaved: "O‘zgarishlar saqlandi",
  },

  entity: {
    title: "Tashkilot ma'lumotlarini qo'shing",
    thirdStepTitle:
      "Iltimos, ma'lumotlarning to'g'riligini tekshiring. Endi siz yuridik shaxsingizni tasdiqlashimiz uchun 24 dan 48 soatgacha kutishingiz kerak.",
    accept: "Men shartnoma shartlarini qabul qilaman",
    offers: "oferta",
    titleReject: "Ariza rad etildi!",
    rejectDescription:
      "Afsuski, taqdim etgan ma'lumotlaringiz noto'g'ri ekanligi aniqlandi. Moderatorlarning javobini diqqat bilan o'qing va yuridik shaxs haqidagi ma'lumotlarda o'zgartirishlar kiriting.",
    message: "Moderatorlardan xabar:",
    change: "Ma'lumotlarni o'zgartirish",
    titleWaiting: "Ro'yxatdan o'tganingiz uchun rahmat!",
    descriptionWaiting:
      "Hozirda tashkilotingiz moderatsiyadan o'tmoqda. Biz ma'lumotlaringizning to'g'riligiga ishonch hosil qilganimizdan so'ng shaxsiy kabinetingizga kira olasiz. Odatda, tekshiruv 24 dan 48 soatgacha davom etadi.",
    descriptionWaitingRu:
      "<p>Hozirda tashkilotingiz moderatsiyadan o'tmoqda. </p> <p>Biz ma'lumotlaringizning to'g'riligiga ishonch hosil qilganimizdan so'ng siz RC Group hamkor kabinetiga kira olasiz. </p> <p> Odatda, tekshiruv 24 dan 48 soatgacha davom etadi.</p>",
    descriptionWaitingRuWithoutPos:
      "<p>Hozirda tashkilotingiz moderatsiyadan o'tmoqda. </p> <p>Biz ma'lumotlaringizning to'g'riligiga ishonch hosil qilganimizdan so'ng siz RC Group hamkor kabinetiga kira olasiz. </p> <p> Odatda, tekshiruv 24 dan 48 soatgacha davom etadi.</p>",
    downloadAccept: "To'lov hisobini yuklab olish",
    addDone: "Yuridik shaxs yaratganingiz bilan tabriklaymiz!",
    waitingApprove:
      "<p>Hozirda yuridik shaxsingiz tekshiruvdan o'tmoqda. Bu 24 dan 48 soatgacha davom etadi.</p><p>Tekshiruvdan o'tish uchun quyidagi tugma orqali yuklab olgan hisob-ni ko'rsatilgan yuridik shaxs hisobidan to'lashingiz kerak. Siz shaxsiy kabinetda ham hisob-ni topishingiz mumkin: «Mening korxonalarim» bo'limida - «Hujjatlar» «Test to'lovi» nomi ostida.</p>",
  },

  contacts: {
    title: "Kontaktlar",
    subtitle:
      "«AXBOROT-MOLIYAVIY TEXNOLOGIYALAR KORPORATSIYASI» AKSIYADORLIK JAMIYATI ( «Infintex korporatsiyasi» AJ ) Yuridik manzil: 191124, <br/> Sankt-Peterburg, Qizil Toʻqimachilar koʻchasi, 10-12, O binosi, 6-qavat, 1-N xonasi, 624-kabinet <br/> INN/KPP 7842216564/784201001 OGRN 1237800080616",
    mailAddress: "Elektron pochta manzili: ",
  },

  failed: "Xato. Amal bajarilmadi",
  success: "Amal bajarildi",

  //cabinet layout
  leftPanel: {
    counterparties: "Kontragentlarni tekshirish",
    entities: "Yuridik shaxslar",
    tradingPoint: "Savdo nuqtalari",
    paymentMethods: "To'lov usullari",
    employees: "Kassirlar",
    documents: "Hujjatlar",
    businesses: "Biznes",
    tariffs: "Tariflar",
    historyPayment: "Operatsiyalar tarixi",
    promotions: "Aksiyalar",
    actsAndAccounts: "Aktlar va hisob-kitoblar",
    accrualCashback: "Balllarni hisoblash",
    managers: "Menejerlar",
    spread: "RC kartalarini tarqatish",
    analytics: "Analitika",
    points: "Kassirlarga balllar",
    enterprises: "Mening korxonalarim",
    paymentDecision: "To'lov qarori",
    portfolio: "Portfel",
    employees_and_managers: "Mening xodimlarim",
    loyalty: "Loyallik dasturi",
    clients: "Mijozlar",
    claims: "Arizalar",
    claims_history: "Ariza tarixi",
    claims_groups: "Mijozlarni guruhlash",
    reviews: "Sharhlar",
    extendTariff: "Tarif muddatini uzaytiring",
    changeTo: "tarif o'zgaradi",
    wallet: "Wallet karta dizayni",
    accountIs: "Siz sifatida kirdingiz",
    manager: "menejer",
    owner: "egasi",
    terminals: "Kassa apparatlari",
    terminals_MSPOS: "RC Processing 4 in 1",
    terminals_LIMON: "MPOS texnologiyasi",
    FAQ: "RC CITY haqida batafsil",
    corporate: "Aloqa",
    push: "Wallet Push-xabarnomalari",
    tips: "Naqd pulsiz choy pullari",
    eMenu: "Onlayn katalog",
    documentLaboratory: "Hujjatlar laboratoriyasi",
    giftCard: "Sovg'a kartalari",
    processing: "Processing",
    services: "Xizmatlar",
    wallets: "Loyallik kartalari",
    clientsList: "Mijozlar ro'yxati",
    marketplaces: "Marketpleyslar",
    PromotionServices: "Targ'ib",
    PreOrders: "Buyurtmalar",
    PWA: "Ilovani o'rnatish",
    tgNotifications: "Telegramda xabarnomalar",
  },
  headerButtons: {
    addCoin: "To'ldirish",
    profile: "Profil",
    exit: "Chiqish",
    themLight: "Yorqin mavzu",
    themDark: "Qorong'i mavzu",
  },

  //check counterparties page
  counterparties: {
    title: "Kontragentlarni tekshirish",
    buttonCheck: "Tekshirish",
    question:
      "Ro'yxatdan o'tish sanasi, INN, KPP, OGRN, Asosiy faoliyat turi, Yur.shaxs statusi, IFNS, Yuridik manzil, Bosh direktor, Tashkilotchilar, Ustav kapitali",
    instructionButton: "Kontragentlarni tekshirish bo'yicha ko'rsatma",
    listTitle:
      "Kontragentlarni tekshirish uchun Botdan qanday foydalanish kerak?",
    listItemFirst:
      "Tekshirmoqchi bo'lgan tashkilotning INN yoki OGRN raqamini kiriting.",
    listItemSecond:
      "Telegram-Bot sizga kerakli barcha ma'lumotlarni ko'rsatadi.",
    listItemThird:
      "Bloklangan hisob-raqamlarni tekshirish uchun «Hisoblarni blokirovkadan tekshirish» tugmasini bosing.",
    listItemFourth:
      "«Hisoblarni blokirovkadan tekshirish» tugmasini bosgandan so'ng Bot barcha bloklangan hisob-raqamlarni (agar mavjud bo'lsa), IFNS, blokirovka sanasini, qaror raqamini, asosini moddaga muvofiq ko'rsatadi. Ushbu ma'lumotni batafsil o'rganish uchun PDF formatida yuklab olish mumkin: «Hisobot faylini yuklab olish» tugmasini bosing.",
    instructionCardTitleFirst: "Kontragentlarni nega tekshirish kerak?",
    instructionCardTitleSecond: "Vaqtida faktlar haqida biling.",
    instructionCardTextFirst:
      "<p>Kontragentlarni tekshirish kontragent bilan ishlashda paydo bo'lishi mumkin bo'lgan moliyaviy va soliq xavflarini aniqlash va hamkorlikni davom ettirish yoki to'xtatish to'g'risida asosli qaror qabul qilish uchun zarur. <br> Bot yangi va joriy kontragentlarni turli manbalar bo'yicha avtomatik teksiradi va sizga kritik omillar va e'tiborga olinishi kerak bo'lgan ma'lumotlar haqida xabar beradi.</p>",
    instructionCardTextSecond:
      "<p>Bot yordamida siz barcha kontragentlar bazasi bo'yicha yoki aniq ajratilgan kontragent bo'yicha ommaviy tekshiruv va o'zgarishlarni monitoring qilishingiz mumkin. Bu mijozlar va hamkorlaringizdagi muhim o'zgarishlarga vaqtida reagirlash imkonini beradi, pul mablag'larini qaytarmaslik xavfini kamaytiradi.</p>",
  },

  // Claims and history claims page
  claims: {
    title: "Arizalar",
    historytitle: "Ariza tarixi",
    group_name: "Guruh nomi",
    group_nomination: "Guruh nomi",
    group_sum: "Sotib olish summasi (chegirmalarsiz)",
    create_group: "Yangi guruh yaratish",
    edit_group: "Guruhni tahrirlash",
    delete_group: "Guruhni o'chirishni xohlaysizmi?",
    sum: "Summa",
    percent: "Hisoblash foizi",
    noClients: "Hozircha sizda bitta ham mijoz bo'lmagan",
    oneClient: "Sizda faqat bitta mijoz bo'lgan",
  },

  // analytic page
  analytics: {
    title: "Analitika",
    organizationSelect: "Yuridik shaxsni tanlang",
    organizationButton: "Yuridik shaxslar",
    organizationCheckbox: "Barcha tashkilotlar",
    newOrganizationCheckbox: "Barcha yuridik shaxslar",
    calendar: "Taqvim",
    organizations: {
      newClients: "Yangi mijozlar",
      allClients: "Barcha mijozlar",
      sales: "Sotuvlar",
      amount: "Sotuvlar summasi",
      amountCashback: "Shundan ballar bilan berilgan",
      average: "O‘rtacha chek",
      averageCashback: "O‘rtacha mukofot",
      ofThem: "Shundan",
      awardedInPoints: "Ballar bilan berilgan",
      acceptedWithPoints: "Ballar bilan qabul qilingan",
      acceptedWithPointsTitle: "Ballar bilan qabul qilingan",
    },
    filterTitles: {
      entity: "Yuridik shaxs",
      tradingPoints: "Savdo nuqtalari",
    },
    countClients: "Mijozlar soni",
    topSumEmployee: "Sotuv summasi bo‘yicha top kassirlar",
    topSaleEmployee: "Sotuvlar bo‘yicha top kassirlar",
    points: "Ballar",
    addPoints: "Ballar hisoblandi",
    writePoints: "Ballar bilan qabul qilindi",
    rfmAnalysis: "RFM tahlili",
    rfmGroupSizes: "RFM guruhlari hajmi",
    clientPortrait: {
      btn: "Mijoz portreti",
      title: "Mijozlar",
      customerCount: "Mijozlar soni:",
      receiptAvg: "O‘rtacha chek:",
      receiptCount: "Sotuvlar soni:",
      receiptSum: "Sotuvlar summasi:",
      maleFemale: "Erkak/Ayol:",
      noGender: "Jinsi ko‘rsatilmagan:",
    },
  },
  // Answer moderation
  status: {
    moderation: "Moderatsiyada",
    confirmation: "Tasdiqlangan",
    confirm: "Tasdiqlandi",
    reject: "Rad etilgan",
    reject2: "Rad etildi",
    paid: "To'langan",
    active: "Faol",
    locked: "Bloklangan",
    activateProcess: "Faollashtirish jarayonida",
    awaitingPayment: "To'lov kutilmoqda",
    sent: "Yuborilgan",
    received: "Qabul qilingan",
    canceled: "Bekor qilingan",
    unknown: "Noma'lum",
    awaitingDocs: "Hujjat yuklanishini kutmoqda",
    base: "Asosiy",
    inProgress: "Ish jarayonida",
    completed: "Yakunlangan",
    new: "Yangi",
    readyForIssue: "Berishga tayyor",
    issuedToClient: "Mijozga berilgan",
    undefined: "Noma'lum",
    performed: "O'tkazilgan",
    inWaiting: "Kutishda",
  },

  // Table
  table: {
    searchByTable: "Jadval bo'yicha qidirish",
    status: "Status",
    nameStatus: "Status nomi",
    percentageAccrual: "Hisoblash foizi",
    fullName: "FIO",
    position: "Lavozim",
    phone: "Telefon raqami",
    login: "Login",
    number: "Raqam",
    sum: "Summa",
    customer: "Xaridor",
    cashback: "Balllar",
    currency: "Valyuta",
    dateTime: "Sana va vaqt",
    date: "Sana",
    paid: "To'langan",
    purchase: "Sotib olish",
    transaction: "Tranzaksiya",
    type: "Turi",
    points: "Balllar",
    name: "Ism",
    visits: "Tashriflar chastotasi",
    averageCheck: "Sotib olishlar summasi",
    birthday: "Tug'ilgan kun",
    age: "Yosh",
    nameAndSurname: "Familiya va Ism",
    store: "Savdo nuqtasi",
    entityName: "Tashkilot nomi",
    operationType: "Operatsiya turi",
    time: "Убакыт",
  },

  // Common text
  common: {
    nodata: "Sizda hali savdo nuqtasi yo'q",
    buttonNoData: "Savdo nuqtasi yaratish",
    organizationSelect: "Tashkilotni tanlang",
    allOrganizationCheckbox: "",
    tradingPointsSelect: "Savdo nuqtasini tanlang",
    allTradingPointsCheckbox: "Barcha savdo nuqtalari",
    from: "dan",
    util: "gacha",
    to: "gacha",
    fillField: "Ushbu maydonni to'ldiring",
    invalidEmail: "Noto'g'ri pochta",
    minLengthPass: "Parol 8 belgidan kam bo'lmasligi kerak",
    fillTime: "Vaqtni to'ldiring",
    calendar: "Kalendar",
    filter: "Filter",
    filters: "Filtrlar",
    back: "Orqaga",
    loadDescription: "Iltimos, mahsulot halolligi sertifikatini yuklang:",
    loadFormat: ".PDF .JPG .PNG formatidagi sertifikatlar qo'llab-quvvatlanadi",
    loadSize: "Fayl og'irligi 10 MB dan oshmasligi kerak",
    dropFiles: "Faylni bu erga torting yoki",
    uploadFiles: "yuklang",
    chooseFile: "Fayl tanlash",
    fileName: "Fayl nomi",
    Monday: "Dushanba",
    Tuesday: "Seshanba",
    Wednesday: "Chorshanba",
    Thursday: "Payshanba",
    Friday: "Juma",
    Saturday: "Shanba",
    Sunday: "Yakshanba",
    MondayShort: "Du",
    TuesdayShort: "Se",
    WednesdayShort: "Chor",
    ThursdayShort: "Pay",
    FridayShort: "Jum",
    SaturdayShort: "Shan",
    SundayShort: "Yak",
    1: "Dushanba",
    2: "Seshanba",
    3: "Chorshanba",
    4: "Payshanba",
    5: "Juma",
    6: "Shanba",
    7: "Yakshanba",
    dayAndNightTime: "Nuqta kechayu-kunduz ishlaydi",
    notWorkTime: "Nuqta ishlamaydi",
    month: "oy",
    mo: "oy",
    year: "yil",
    organizations: "Tashkilotlar",
    shops: "Savdo nuqtalari",
    employees: "Kassirlar",
    managers: "Menejerlar",
    manager: "Menejer",
    owner: "Egasi",
    business: "Biznes",
    tariffs: "Tariflar",
    historyOperations: "Operatsiyalar tarixi",
    actsAndAccounts: "Aktlar va hisob-kitoblar",
    cashback: "Balllarni hisoblash",
    documents: "Hujjatlar",
    addBalance: "Oldindan to'lov",
    addPoints: "Balllarni hisoblash",
    application: "Kassa apparatini to'lash",
    claims: "Arizalar",
    analytics: "Analitika",
    sortNew: "Yangi bo'yicha",
    sortAscStars: "Yulduzlar kamayishi bo'yicha",
    sortDscStars: "Yulduzlar o'sishi bo'yicha",
    email: "email",
    lastName: "Familiya",
    firstName: "Ism",
    error404: "Xato 404",
    noPage: "Sahifa topilmadi",
    errorTypeFile: "Noto'g'ri fayl turi!",
    tryTypeFile: "Fayl jpg yoki png bo'lishi kerak",
    clients: "Mijozlar",
    exitAccount: "Hisobdan chiqish",
    accountsForAct: "Akt bo'yicha hisob",
    downloadOn: "da mavjud",
    downloadOnRuStore: "dan yuklab oling",
    phone: "Telefon",
    comment: "Izoh",
    pcs: "dona",
    gb: "GB",
    min: "daq",
    group: "Guruh",
    emptyField: "Barcha maydonlarni to'ldiring",
    correctField: "Barcha maydonlar to'g'ri bo'lishi kerak!",
    bigFile: "Fayl hajmi katta",
    "e-menu": "Elektron menyu",
    "document-laboratory": "Hujjatlar laboratoriyasi",
    changesNotSaved: "Kiritilgan o'zgarishlar saqlanmadi",
    statuses: "Statuslar",
    phoneNumber: "Telefon raqami",
    mail: "Elektron pochta",
    tgBot: "Telegram bot",
  },

  // Buttons
  button: {
    invite: "Taklif qilish",
    download: "Yuklab olish",
    edit: "Tahrirlash",
    save: "Saqlash",
    saveChange: "O'zgarishlarni saqlash",
    saveAndQuit: "Saqlash va chiqish",
    accept: "Qabul qilish",
    change: "O'zgartirish",
    login: "Kirish",
    create: "Yaratish",
    confirm: "Tasdiqlash",
    details: "Batafsil",
    copy: "Nusxalash",
    topUp: "To'ldirish",
    back: "Orqaga",
    send: "Yuborish",
    sendAgain: "Qayta yuborish",
    sendCode: "Kod yuborish",
    next: "Keyingi",
    proceed: "Davom etish",
    buy: "Sotib olish",
    goto: "O'tish",
    open: "Ochish",
    delete: "O'chirish",
    cancel: "Bekor qilish",
    cancel2: "Bekor qilish",
    yesCancel: "Ha, bekor qilish",
    yesQuit: "Ha, chiqish",
    yesDelete: "Ha, o'chirish",
    pay: "To'lash",
    ok: "Yaxshi!",
    cancelClaim: "Arizani bekor qilish",
    generate: "Yaratish",
    apply: "Qo'llash",
    applyAndClose: "Qo'llash va yopish",
    reset: "Tiklash",
    clearAll: "Hammasini tozalash",
    calendarButton: {
      today: "Bugun",
      yesterday: "Kecha",
      lastWeek: "Oxirgi 7 kun",
      last30Days: "Oxirgi 30 kun",
      lastMonth: "O'tgan oy",
      thisMonth: "Shu oy",
      lastYear: "O'tgan yil",
      thisYear: "Joriy yil",
      allPeriod: "Butun davr",
      selectRange: "O'z davri",
    },
    preview: "Oldindan ko'rish",
    resetAll: "Hammasini tiklash",
    showResult: "Natijalarni ko'rsatish",
    upload: "Yuklash",
    expand: "Yoyish",
    hide: "Yashirish",
    try: "Sinab ko'rish",
    add: "Qo'shish",
    reveal: "Ko'rsatish",
    readAll: "To'liq o'qish",
    collapse: "Yig'ish",
    logout: "Chiqish",
    show: "Ko'rsatish",
    moreDetails: "Batafsil",
    settings: "Sozlamalar",
    rollUp: "Yig'ish",
    rollUpAll: "Barchasini yig‘ish",
    toTariffs: "Tariflarga",
    forModeration: "Moderatsiyaga",
    quitWithoutSaving: "Saqlamasdan chiqish",
    downloadInvoice: "Hisobni yuklab olish",
    notNow: "Hozir emas",
    createCashier: "Kassir yaratish",
    clearly: "Tushunarli",
    toEdit: "Tahrirlashga",
    skip: "O'tkazib yuborish",
    backAndSave: "Qaytish va saqlash",
    done: "Tayyor",
    close: "Yopish",
  },

  month: {
    1: "Yanvar",
    2: "Fevral",
    3: "Mart",
    4: "Aprel",
    5: "May",
    6: "Iyun",
    7: "Iyul",
    8: "Avgust",
    9: "Sentabr",
    10: "Oktabr",
    11: "Noyabr",
    12: "Dekabr",
  },

  charts: {
    pointsAccrued: "Hisoblangan balllar",
    pointsWritten: "Balllar bilan qabul qilingan",
  },

  eMenu: {
    noData: {
      title: "Elektron menyu bo'yicha ma'lumot yo'q",
      noTradingPoints: "Sizda hali Savdo nuqtalari yo'q ",
      noProducts: "Sizda hali bitta ham mahsulot yaratilmagan",
    },
  },

  validationErrors: {
    emptyField: "Maydon bo'sh bo'lishi mumkin emas",
    invalidEmailFormat: "{email} ko'rinishida email kiriting",
    invalidSiteFormat: "URL http:// yoki https:// ni o'z ichiga olishi kerak",
    invalidFormat: "Noto'g'ri format",
    incorrectValueStart: "Dan qiymatini ko'rsatish kerak",
    incorrectValueEnd: "gacha",
    invalidValueMaxLength: "Maksimal belgilar soni ",
    invalidValueMinLength: "Minimal belgilar soni ",
    invalidHouseNumber: "Uy raqamini aniq lang",
    invalidAddress: "Manzilni aniq lang",
    writeFullAddress: "Manzilni aniqlang: ko‘cha, uy / bino / inshoot",
    invalidWorkDays: "Kamida bitta ish kuni tanlashingiz kerak",
    invalidWorkTime: "Noto'g'ri vaqt formati",
    errorWorkTime:
      "Ochilish vaqti yopilish vaqtidan keyin yoki unga teng bo'lishi mumkin emas",
    notEnoughElement: "Elementlar soni yetarli emas",
    manyElement: "Siz maksimal elementlar sonini oshirdingiz",
    maxLessMin: "Minimaldan kam",
    invalidAge: "Noto'g'ri yosh",
    minDate: "Sana {date} dan kech bo'lmasligi kerak",
    maxDate: "Sana {date} dan erta bo'lmasligi kerak",
    requiredPhone: "Telefon raqamini kiriting",
    reqiredPromocode: "Promokod noto'g'ri kiritilgan",
    requiredCountry: "Mamlakatni tanlashingiz kerak",
    havePhone: "Ushbu telefon allaqachon ro'yxatdan o'tgan",
    haveMail: "Ushbu pochta allaqachon ro'yxatdan o'tgan",
    invalidEmail: "Noto'g'ri pochta",
    email: "Pochtani kiriting",
    first_name: "Ismni kiriting",
    last_name: "Familiyani kiriting",
    password: "Parolni kiriting",
    corresp_account: "Korrespodent hisobni ko'rsatish kerak",
    number_account: "Hisob raqamini ko'rsatish kerak",
    commercial_account_number:
      "Hisob raqami yur.shaxsga yoki YaTTga tegishli bo'lishi kerak",
    bik_of_bank: "Bank BIK ni ko'rsatish kerak",
    mfo_of_bank: "Bank MMTni ko‘rsatish kerak",
    international_bank: "Xalqaro bank hisob raqamini ko'rsatish kerak",
    vat_code: "QQS kodini ko'rsatish kerak",
    inn: "INN ni ko'rsatish kerak",
    entityAddress: "Yuridik manzilni ko'rsatish kerak",
    fullName: "FIO ni ko'rsatish kerak",
    ogrn: "OGRN ni ko'rsatish kerak",
    monthly_turnover: "Oylik aylanma miqdorini ko'rsatish kerak",
    deposit_sum: "Depozit miqdorini ko'rsatish kerak",
    tax_system: "Soliq tizimi turini ko'rsatish kerak",
    legal_type: "Yur.shaxs shaklini ko'rsatish kerak",
    okved_code: "Asosiy faoliyat turini ko'rsatish kerak",
    minFillingPhotos: "Minimal fayllar soni - {amount}",
    notValidPromocode: "Promokod mavjud emas",
    cyrillicOnly: "Faqat kirill va lotin",
    haveInn: "Ushbu {option} bilan yur.shaxs allaqachon mavjud",
    addressWithoutNumber: "Bino/qurilma, xonaning raqamini ko'rsatish kerak",
    login: "Loginni kiriting",
    empryNamedField: "{option} ni ko'rsatish kerak",
    passwordMismatch: "Parollar mos kelmadi",
    address: "Bino/qurilma, xonaning raqami bilan manzilni ko'rsatish kerak",
    fieldLengthFromTo:
      "Maydon {from} dan {to} gacha raqamlarni o'z ichiga olishi kerak",
    necessaryEnterMinChars: "Kamida {minChars} belgi kiriting",
    workHours: "Tanlangan kunlarda ish soatlarini ko'rsating",
    timeFormat: "Noto'g'ri vaqt formati",
    minImagesUpload: "Kamida {minImages} tasvir yuklang",
    wrongMailOrPassword: "Noto‘g‘ri pochta yoki parol",
    wrongLoginOrPassword: "Noto‘g‘ri login yoki parol",
    needEnterMinRC: "Kamida {amount} RC kiritish kerak",
  },

  tooltips: {
    registration: {
      deposit:
        "Hisobdagi minimal qoldiq. Mablag'larni yechib olishda balansda qoladigan summa.",
    },
  },

  globalMessagesButton: {
    "tt-update": "Yangi «Savdo nuqtalari» bo'limiga o'ting",
    "clients-update": "Sinab ko'rish",
    "product-release": "Sinab ko'rish",
    "review-update-release": "Sinab ko'rish",
  },

  declinationHelperWords: {
    years: [" yil", " yil", " yil"],
    days: [" kun", " kun", " kun"],
    grades: [" baho", " baho", " baho"],
    symbols: [" belgi", " belgi", " belgi"],
    result: [" natija", " natija", " natija"],
    review: [" sharh", " sharh", " sharh"],
    star: [" yulduz", " yulduz", " yulduz"],
    clients: [" mijoz", " mijoz", " mijoz"],
    product: [" mahsulot", " mahsulot", " mahsulot"],
    entities: [" yur.shaxs", " yur.shaxs", " yur.shaxs"],
  },

  noData: {
    title: "Ma'lumot yo'q",
    emptyHistory: "Sizning tarixingiz bo'sh",
  },

  mobileFiltersName: {
    "trading-points": "Savdo nuqtalari",
    category: "Kategoriya",
    "product-status": "Mahsulot statusi",
    "review-status": "Sharh turi",
    sort: "Saralash",
    date: "Davr",
  },

  debt: {
    title: "Qarz",
    text: "Uni elektron pochtaga yuborilgan hisob orqali to'lang yoki uni mustaqil ravishda «Balans» bo'limida yarating",
    link: "Qarzni to'lashga o'ting",
    message:
      "Siz {debt}&nbsp;{currency} miqdoridagi qarzni to'lashingiz kerak <br> To'lovni quyidagi usullardan biri bilan amalga oshirish mumkin: shaxsiy kabinetda hisob yaratish yoki elektron pochtaga yuborilgan hisobni yuklab olish.",
  },

  promotionServices: {
    servicesList: {
      "xxl-tag": {
        name: "XXL-o'lchamli karta",
        description:
          "Muassasangiz kartasining o'lchamini oshirish va unga «Top joy» yorlig'ini joylashtirish",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Sizning muassasangiz kartasi rcpay.ru saytidagi va RC PAY mobil ilovasidagi «Muassasalar» sahifasida unga tegishli bo'lgan shahar va kategoriya doirasida o'lchami oshirilgan va «Top joy» yorlig'i bilan ajralib turadi.</p></li>" +
          "<li><span>●</span><p>Joylashtirish muddati - hamkor kabinetida buyurtma rasmiylashtirilgan va to'langandan boshlab 1 hafta, 1 oy yoki 3 oy.</p></li>" +
          "<li><span>●</span><p>Joylashtirish muddatini buyurtma berish bosqichida tanlash mumkin.</p></li>" +
          "<li><span>●</span><p>Ushbu xizmatni buyurtma qilganingizda, siz xaritada muassasangizning maxsus belgisini ham olasiz.</p></li>" +
          "</ul>",
      },
      tag: {
        name: "«Top joy» yorlig'i",
        description:
          "Muassasangiz kartasiga «Top joy» yorlig'ini joylashtirish va uni umumiy ro'yxatda yuqoriga ko'chirish",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Sizning muassasangiz kartasi rcpay.ru saytidagi va RC PAY mobil ilovasidagi «Muassasalar» sahifasidagi ro'yxatda «Top joy» yorlig'i bilan ajralib turadi va yuqoriga ko'chiriladi.</p></li>" +
          "<li><span>●</span><p>Joylashtirish muddati - hamkor kabinetida buyurtma rasmiylashtirilgan va to'langandan boshlab 1 hafta, 2 hafta, 1 oy yoki 3 oy.</p></li>" +
          "<li><span>●</span><p>Joylashtirish muddatini buyurtma berish bosqichida tanlash mumkin.</p></li>" +
          "<li><span>●</span><p>Ushbu xizmatni buyurtma qilganingizda, siz xaritada muassasangizning maxsus belgisini ham olasiz.</p></li>" +
          "</ul>",
      },
      top: {
        name: "1 yoki 2-o'rin",
        description:
          "Muassasangiz kartasini ro'yxatda 1 yoki 2-o'rinlarda joylashtirish (uning tashqi ko'rinishi va o'lchamini o'zgartirmasdan)",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Sizning muassasangiz kartasi rcpay.ru saytidagi va RC PAY mobil ilovasidagi «Muassasalar» sahifasidagi ro'yxatda 1 yoki 2-o'rinda joylashtiriladi.</p></li>" +
          "<li><span>●</span><p>1 yoki 2-o'rinda joylashtirish ushbu xizmatni buyurtma qilish va to'lash tartibiga qarab belgilanadi.</p></li>" +
          "<li><span>●</span><p>Joylashtirish muddati - hamkor kabinetida buyurtma rasmiylashtirilgan va to'langandan boshlab 2 hafta.</p></li>" +
          "<li><span>●</span><p>Ushbu xizmatni buyurtma qilganingizda, siz xaritada muassasangizning maxsus belgisini ham olasiz.</p></li>" +
          "</ul>",
      },
      hint: "Hozirda savdo nuqtangiz shahridagi ushbu xizmat bo'yicha barcha mavjud slotlar band. Buyurtma berish ko'rsatilgan sanadan boshlab mumkin bo'ladi.",
    },
    periodsList: {
      "7 days": "1 hafta",
      "14 days": "2 hafta",
      "30 days": "1 oy (30 kun)",
      "90 days": "3 oy (90 kun)",
    },
  },
};
